import React from 'react';
import { toast, Slide } from 'react-toastify';
import CustomToast from './CustomToast';

const TOAST_TYPES = {
  success: { title: 'Success' },
  error: { title: 'Error' },
  warning: { title: 'Warning' },
  info: { title: 'Informative' },
};

const defaultOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  transition: Slide,
  icon: false,
  closeButton: false,
  className: 'serveiq-toast-wrapper',
  bodyClassName: 'serveiq-toast-body',
};

const showToast = (type, message) => {
  const { title } = TOAST_TYPES[type];
  toast(
    <CustomToast type={type} title={title} description={message} />,
    defaultOptions
  );
};

export const showErrorToast = (message) => showToast('error', message);

export const showWarningToast = (message) => showToast('warning', message);

export const showInfoToast = (message) => showToast('info', message);

export const showSuccessToast = (message) => showToast('success', message);

export default showErrorToast;
